import script from "./Container.vue?vue&type=script&setup=true&lang=js"
export * from "./Container.vue?vue&type=script&setup=true&lang=js"

import "./Container.vue?vue&type=style&index=0&id=61a53da2&lang=scss&scoped=true"
script.__scopeId = "data-v-61a53da2"

export default script